import React from "react";
import _RCSLog from "../../../components/reports/rcslogs/_RCSLog";
const RCSLogs = () => {
  return <_RCSLog />;
};

export default RCSLogs;
